import { useTheme } from 'styled-components';

import { Icon } from '@/core/components/Icons';
import { MultiButton, MultiButtonItem } from '@/core/components/MultiButton';
import { ReportReadSwitchStatus } from '@/core/interfaces/common';

import { ReadStatusSwitchContainer } from './ReadStatusSwitch.styles';
import { ReadStatusSwitchProps } from './ReadStatusSwitch.types';

const reportReadOptions: Array<MultiButtonItem<ReportReadSwitchStatus>> = [
  {
    label: 'All',
    value: ReportReadSwitchStatus.ALL,
  },
  {
    label: 'Unread',
    value: ReportReadSwitchStatus.UNREAD,
  },
];

export const ReadStatusSwitch = ({ activeStatus, onStatusChange }: ReadStatusSwitchProps) => {
  const { colors } = useTheme();

  return (
    <ReadStatusSwitchContainer>
      <Icon
        name="Envelope"
        color={colors.secondaryText}
        size={16}
      />
      <MultiButton
        isSmall
        active={activeStatus}
        tabsData={reportReadOptions}
        onChange={onStatusChange}
      />
    </ReadStatusSwitchContainer>
  );
};
